<script lang="ts">
  // Шапка сайта с навигацией
</script>

<header class="header">
  <div class="container">
    <div class="header-content">
      <div class="logo">
        <img src="/images/blindeye-logo.svg" alt="BlindEye VPN Logo" class="logo-img" />
        <h1 class="logo-text">BlindEye VPN</h1>
      </div>
      
      <nav class="nav">
        <ul class="nav-list">
          <li class="nav-item"><a href="#features" class="nav-link">Возможности</a></li>
          <li class="nav-item"><a href="#pricing" class="nav-link">Цены</a></li>
          <li class="nav-item"><a href="#download" class="nav-link">Скачать</a></li>
          <li class="nav-item"><a href="#faq" class="nav-link">FAQ</a></li>
        </ul>
      </nav>
      
      <div class="auth-buttons">
        <a href="#login" class="btn btn-text">Войти</a>
        <a href="#signup" class="btn btn-primary">Регистрация</a>
      </div>
    </div>
  </div>
</header>

<style>
  .header {
    padding: 1.5rem 0;
    position: relative;
    z-index: 10;
  }
  
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .logo {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
  
  .logo-img {
    height: 2.5rem;
    width: auto;
  }
  
  .logo-text {
    font-weight: 900;
    font-size: 1.5rem;
    margin: 0;
    background: linear-gradient(45deg, var(--sauron-red), var(--sauron-yellow));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .nav-list {
    display: flex;
    list-style: none;
    gap: 1.5rem;
    margin: 0;
    padding: 0;
  }
  
  .nav-link {
    color: inherit;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;
  }
  
  .nav-link:hover {
    color: var(--sauron-red);
  }
  
  .auth-buttons {
    display: flex;
    gap: 1rem;
    align-items: center;
  }
  
  .btn-text {
    color: inherit;
    text-decoration: none;
    font-weight: 600;
    transition: color 0.3s ease;
  }
  
  .btn-text:hover {
    color: var(--sauron-red);
  }
  
  /* Адаптивная версия для мобильных */
  @media (max-width: 768px) {
    .header-content {
      flex-direction: column;
      gap: 1rem;
    }
    
    .nav {
      width: 100%;
      order: 3;
    }
    
    .nav-list {
      justify-content: center;
      flex-wrap: wrap;
    }
    
    .auth-buttons {
      order: 2;
    }
  }
</style> 